'use client';
import styled, { keyframes } from 'styled-components';
const defaultSize = '16px';
export const Body = styled.div `
  height: ${o => o.size || defaultSize};
  width: ${o => o.size || defaultSize};
`;
const rotate = keyframes `
  0% {
    transform: rotate(-90deg);
  }

  100% {
    transform: rotate(270deg);
  }
`;
export const Svg = styled.svg `
  animation: ${rotate} 2s linear infinite;
`;
const dash = keyframes `
  0% {
    stroke-dasharray: 8 140;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 138;
    stroke-dashoffset: -10;
  }

  100% {
    stroke-dasharray: 8 140;
    stroke-dashoffset: -148;
  }
`;
export const Circle = styled.circle `
  animation: ${dash} 2s ease-out infinite;
  stroke: ${o => o.strokeColor || o.theme.color.deprecated.obsidianLighter};
`;
//# sourceMappingURL=styles.js.map